module.exports = __webpack_public_path__ + "img/baad1708585b36ec5e0e94993ef41991.png";


//////////////////
// WEBPACK FOOTER
// ./src/scripts/lib/images/finance_logo11.png
// module id = 919
// module chunks = 5